<template>
  <div class="one-column-width">



    <!-- form start -->
    <v-card class="r_tabsform_card mb-5" >
    <v-card-title class="r_form_card_title ext_pdg_to_lvl"> Invite Uni Mates</v-card-title>
    <hr class="r_form_card_top_hr">

    <div class="col-md-11  m-5">
        <div class="col-md-12 row">
        <div class="col-md-4">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <input class="r_formtabs_inputs m-0 w-100" placeholder="Name" />
        </div>

        <div class="col-md-4">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <input class="r_formtabs_inputs m-0 w-100" placeholder="Email" />
        </div>

        <div class="col-md-4">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <input class="r_formtabs_inputs m-0 w-100" placeholder="Institute" />
        </div>

        <div class="col-md-3">
            <button
                type="button"
                class="r_form_add_more_btnnn m-0"
            >
                Invite
            </button>
        </div>
        
        
        </div>
    </div>
    <br />
    </v-card>
    <!-- form end -->
  </div>
</template>

<script>
import AdmissionForm from "@/MainServices/AdmissionForm.js";
import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      errorMessage: false,
      search: "",
    };
  },
  components: {},

   computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    getInititalData() {
      AdmissionForm.getStudentApplications()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    
  },
  mounted() {
    this.getInititalData();
  },
};
</script>

<style scoped>
.text-success {
    color: #2eca8b !important;
}
.text-danger {
    color: #a82511 !important;
}

</style>
